// eslint-disable-next-line no-restricted-imports
import {
  BiographyDto_Input,
  Query_ClientController_GetList_AllOf_1_List_Items_Representative_Biography_MaritalStatus as MaritalStatusApi,
  Query_ClientController_GetList_AllOf_1_List_Items_Representative_Biography_Occupation as OccupationApi,
} from 'api/generated/graphql';
import { MaritalStatusType, OccupationType } from 'api/types/entity';
import { BiographyParam } from 'api/types/params';
import { formatToISODate } from 'helpers';

const maritalStatus: Record<MaritalStatusType, MaritalStatusApi> = {
  [MaritalStatusType.married]: MaritalStatusApi.Married,
  [MaritalStatusType.single]: MaritalStatusApi.Single,
};
const occupation: Record<OccupationType, OccupationApi> = {
  [OccupationType.businessOwner]: OccupationApi.BusinessOwner,
  [OccupationType.employee]: OccupationApi.Employee,
  [OccupationType.entrepreneur]: OccupationApi.Entrepreneur,
  [OccupationType.retired]: OccupationApi.Retired,
  [OccupationType.student]: OccupationApi.Student,
  [OccupationType.unemployed]: OccupationApi.Unemployed,
};

export const parseBiographyParam = (
  biography: BiographyParam
): BiographyDto_Input => ({
  ...biography,

  occupation: occupation[biography.occupation],
  maritalStatus: maritalStatus[biography.maritalStatus],

  registrationDate: biography.registrationDate
    ? formatToISODate(biography.registrationDate)
    : undefined,
});
